import { render } from "./search-box-results.vue?vue&type=template&id=60ae4222&scoped=true&lang=pug"
const script = {}

import "./search-box-results.vue?vue&type=style&index=0&id=60ae4222&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60ae4222"]])

export default __exports__